import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What time are your after-school classes?',
  answer: 'We have classes starting at 4:30 PM for ages 3-5, and 5:00 PM or 6:00 PM for ages 6 and up, making it easy to fit into your after-school routine.'
}, {
  question: 'Does my child need experience?',
  answer: 'No experience is needed! Our beginner classes are designed to help new students feel welcome and confident from day one.'
}, {
  question: 'Is this a daycare program?',
  answer: 'No, we are a structured martial arts school. Parents typically drop off or watch class from our viewing area during the 30-60 minute session.'
}, {
  question: 'How does the free week work?',
  answer: "Simply fill out the form, and we will contact you to schedule your child's first visit. They can try classes for a full week with no obligation."
}];
export function AfterSchoolFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-642" />;
}